/**
 *  @class
 *  @function SidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class SidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.headings = this.drawer.querySelectorAll('.side-panel--heading');
      this.panels = this.drawer.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          let panel = this.toggleActiveClass(i, item.dataset.panelKey);
          OverlayManager.open(this.drawer);
          if (panel) {
            requestAnimationFrame(() => {
              this.runPanelScripts(panel);
            });
          }
        });
      });
    }
    toggleActiveClass(i, panelKey) {
      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.headings.forEach((heading) => {
        heading.classList.remove('tab-active');
      });
      let panel = panelKey ? this.drawer.querySelector(`.side-panel-content--tab-panel[data-panel-key="${panelKey}"]`) : this.panels[i];
      let heading = panelKey ? this.drawer.querySelector(`.side-panel--heading[data-panel-key="${panelKey}"]`) : this.headings[i];

      if (panel) panel.classList.add('tab-active');
      if (heading) heading.classList.add('tab-active');
      if (panelKey) this.drawer.dataset.activePanelKey = panelKey;
      return panel;
    }
    runPanelScripts(panel) {
      panel.querySelectorAll('script').forEach((script) => {
        if (script.dataset.executed === 'true') return;

        let newScript = document.createElement('script');

        Array.from(script.attributes).forEach((attribute) => {
          newScript.setAttribute(attribute.name, attribute.value);
        });

        if (script.dataset.sidePanelScript !== undefined) {
          newScript.removeAttribute('type');
          newScript.removeAttribute('data-side-panel-script');
        }

        newScript.dataset.executed = 'true';

        if (!script.src) {
          let originalWrite = document.write;
          let originalWriteln = document.writeln;
          let output = '';

          document.write = (content) => {
            output += content;
          };
          document.writeln = (content) => {
            output += `${content}\n`;
          };

          try {
            newScript.text = script.textContent;
            script.replaceWith(newScript);
          } finally {
            document.write = originalWrite;
            document.writeln = originalWriteln;
          }

          if (output) {
            newScript.insertAdjacentHTML('afterend', output);
          }
          return;
        }

        let originalWrite = document.write;
        let originalWriteln = document.writeln;
        let output = '';
        let restoreDocumentWrite = () => {
          document.write = originalWrite;
          document.writeln = originalWriteln;
          if (output) {
            newScript.insertAdjacentHTML('afterend', output);
            output = '';
          }
        };

        document.write = (content) => {
          output += content;
        };
        document.writeln = (content) => {
          output += `${content}\n`;
        };

        newScript.addEventListener('load', restoreDocumentWrite, { once: true });
        newScript.addEventListener('error', restoreDocumentWrite, { once: true });
        setTimeout(restoreDocumentWrite, 5000);
        script.replaceWith(newScript);
      });
    }
  }

  customElements.define('side-panel-links', SidePanelLinks);
}
